/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_EvalsInputs */

const en_svchip_evals = /** @type {(inputs: Svchip_EvalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evals`)
};

const ar_svchip_evals = /** @type {(inputs: Svchip_EvalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التقييمات`)
};

const bn_svchip_evals = /** @type {(inputs: Svchip_EvalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ইভাল`)
};

const de_svchip_evals = /** @type {(inputs: Svchip_EvalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auswertungen`)
};

const es_svchip_evals = /** @type {(inputs: Svchip_EvalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evaluaciones`)
};

const fr_svchip_evals = /** @type {(inputs: Svchip_EvalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Évaluations`)
};

const pt_svchip_evals = /** @type {(inputs: Svchip_EvalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avaliações`)
};

const zh_svchip_evals = /** @type {(inputs: Svchip_EvalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`评估`)
};

const tr_svchip_evals = /** @type {(inputs: Svchip_EvalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Değerlendirmeler`)
};

const ru_svchip_evals = /** @type {(inputs: Svchip_EvalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оценки`)
};

const pl_svchip_evals = /** @type {(inputs: Svchip_EvalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wartości`)
};

/**
* | output |
* | --- |
* | "Evals" |
*
* @param {Svchip_EvalsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_evals = /** @type {((inputs?: Svchip_EvalsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_EvalsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_evals(inputs)
	if (locale === "bn") return bn_svchip_evals(inputs)
	if (locale === "de") return de_svchip_evals(inputs)
	if (locale === "es") return es_svchip_evals(inputs)
	if (locale === "fr") return fr_svchip_evals(inputs)
	if (locale === "pt") return pt_svchip_evals(inputs)
	if (locale === "zh") return zh_svchip_evals(inputs)
	if (locale === "tr") return tr_svchip_evals(inputs)
	if (locale === "ru") return ru_svchip_evals(inputs)
	if (locale === "pl") return pl_svchip_evals(inputs)
	return en_svchip_evals(inputs)
});